import { lazy } from "react";

export const PartnersPage = lazy(() =>
  import("./ui/partners").then((module) => ({
    default: module.Partners,
  }))
);
